import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type {
    GetSkillResourceResponse,
    UseGetSkillResourceParams,
    UseGetSkillResourceResult,
} from '../types';

/**
 * Fetches a single skill resource (reference) including its content. Backs the
 * editor view when a reference file is selected.
 */
const useGetSkillResource = ({
    skillId,
    resourceId,
    enabled = true,
}: UseGetSkillResourceParams): UseGetSkillResourceResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<GetSkillResourceResponse>({
        pathname: `/skills/${skillId}/resources/${resourceId}`,
        method: 'GET',
        key: ['skill-resource', skillId, resourceId],
        queryOptions: {
            enabled: enabled && Boolean(skillId) && Boolean(resourceId),
        },
    });

    return {
        resource: data?.data ?? null,
        isLoadingResource: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useGetSkillResource;
